import { render } from "./TicketGrantModal.vue?vue&type=template&id=f5dad140"
import script from "./TicketGrantModal.vue?vue&type=script&lang=js"
export * from "./TicketGrantModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__